module.exports = __webpack_public_path__ + "media/waves6.71c21d9a.ogg";